export const SecurityTipsConstants = {
  sectionHeading: 16,
  minimumLength: 0,
  videoDescription: 50,
  imageDescription: 50,
  description: 5000,
};
